import { render, staticRenderFns } from "./JobFollowers.vue?vue&type=template&id=0aa554cc&"
import script from "./JobFollowers.vue?vue&type=script&lang=js&"
export * from "./JobFollowers.vue?vue&type=script&lang=js&"
import style0 from "./JobFollowers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports